@if (openNow()) {
  <span
    class="inline-flex items-center rounded-md bg-primary-500 px-2 py-1 text-xs font-bold text-white whitespace-nowrap"
    >Open today</span
  >
}

@if (listing().openTomorrow) {
  <span
    class="inline-flex items-center rounded-md bg-villages-feature-flag-500 px-2 py-1 text-xs font-bold text-primary-500 whitespace-nowrap backdrop-blur-[2px]"
    >Open tomorrow</span
  >
}
